import { InformationBaseView } from 'General/Views/Static/Information/InformationBaseView';

export class InformationView extends InformationBaseView{ }